import React from 'react';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faTimes,
    faUpRightAndDownLeftFromCenter,
    faWindowMinimize,
} from '@fortawesome/free-solid-svg-icons';
import CommonContext from '../../Common';
import {
    FlexBetweenRow, FormCircularProgress, IconButton,
} from '../forms/FormElements';
import './index.scss';

const getBodyIsOverflowing = () => document.body.clientWidth < window.innerWidth;

export default class Slideout extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.state = {
            isMinimized: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { show, isSelfManagedForm } = this.props;
        const { show: prevShow } = prevProps;

        const { isMinimized } = this.state;
        const { isMinimized: prevMinimized } = prevState;

        if (show !== prevShow || (show && isMinimized !== prevMinimized)) {
            if (show && !isMinimized) {
                const windowOverflow = getBodyIsOverflowing();

                document.body.classList.add('slideform-open');

                if (windowOverflow) {
                    document.body.classList.add('overflow');
                }
            } else if (prevShow === true || isMinimized) {
                document.body.classList.remove('slideform-open', 'overflow');
            }
        }

        if (isSelfManagedForm && show !== prevShow) {
            const { setFormOpened } = this.context;
            setFormOpened(show);
        }

        if (show !== prevShow) {
            this.setState({ isMinimized: false });
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('slideform-open', 'overflow');
    }

    toggleMinimize = () => {
        const { isMinimized } = this.state;

        this.setState({ isMinimized: !isMinimized });
    };

    renderHeader = (header) => {
        const {
            showNav,
            minimize,
            formTitle,
            formIcon,
            onNavBack,
            onNavForward,
            onClose,
        } = this.props;

        return (
            <header className="slide-form-header border-bottom d-flex flex-column position-relative mb-0">
                <FlexBetweenRow className="h5 slide-form-title mb-0 pt-3 pl-3 pr-3">
                    {Boolean(formTitle) && (
                        <div className="d-flex">
                            {Boolean(formIcon) && (
                                <FontAwesomeIcon
                                    className="slide-form-icon mr-2 text-muted"
                                    icon={formIcon}
                                />
                            )}

                            <div>{formTitle}</div>
                        </div>
                    )}

                    <div className="d-flex">
                        {Boolean(minimize) && (
                            <IconButton
                                onClick={this.toggleMinimize}
                                className="mr-2 slide-form-minimize"
                                title="Minimize"
                                type="button"
                                size="lg"
                            >
                                <FontAwesomeIcon
                                    icon={this.state.isMinimized ? faUpRightAndDownLeftFromCenter : faWindowMinimize}
                                />
                            </IconButton>
                        )}

                        {Boolean(showNav) && (
                            <div className="d-flex mr-5">
                                <IconButton
                                    onClick={onNavBack}
                                    className="mr-2"
                                    title="Navigate Back"
                                    type="button"
                                    size="lg"
                                >
                                    <FontAwesomeIcon
                                        icon={faAngleDoubleLeft}
                                    />
                                </IconButton>

                                <IconButton
                                    onClick={onNavForward}
                                    title="Navigate Forward"
                                    type="button"
                                    size="lg"
                                >
                                    <FontAwesomeIcon
                                        icon={faAngleDoubleRight}
                                    />
                                </IconButton>
                            </div>
                        )}

                        <IconButton
                            onClick={onClose}
                            type="button"
                            title="Close"
                            size="lg"
                        >
                            <FontAwesomeIcon
                                icon={faTimes}
                            />
                        </IconButton>
                    </div>
                </FlexBetweenRow>

                {header}
            </header>
        );
    };

    renderBody = () => {
        const { loading, children } = this.props;

        if (loading) {
            return (
                <div className="page-form">
                    <FormCircularProgress />
                </div>
            );
        }

        if (typeof children === 'function') {
            return children(this.renderHeader);
        }

        return (
            <div className="page-form">
                {this.renderHeader()}

                <div className="p-3">
                    {children}
                </div>
            </div>
        );
    };

    render() {
        const {
            className,
            size,
            show,
            fromLeft,
            fullScreen = false,
            onClose,
        } = this.props;

        return (
            <div
                className={cls(`slide-form ${className ?? ''} `, {
                    'col-xl-4 col-md-6 col-sm-12': !size,
                    show,
                    fullScreen,
                    [size]: !!size,
                    left: !!fromLeft,
                    minimized: this.state.isMinimized,
                })}
            >
                {!fullScreen && (
                    <div
                        className={cls('modal-backdrop', {
                            show,
                        })}
                        onClick={onClose}
                        role="presentation"
                    />
                )}

                {Boolean(show) && this.renderBody()}
            </div>
        );
    }
}
